var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg122(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "135") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-night",
    transform: "translate(-927.000000, -6.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: 135,
    transform: "translate(927.398961, 13.396364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.48311688,0 C7.60342217,0 8.65735029,0.28414858 9.57676402,0.78430852 C7.75027743,2.32525347 6.52822983,4.55970479 6.31645091,7.08155844 L6.31645091,7.08155844 L5.78523429,7.08155844 C3.73949522,7.08155844 1.92626436,8.07432304 0.80064591,9.60423403 C0.289966462,8.67881302 0,7.61483307 0,6.48311688 C0,2.9025413 2.9025413,0 6.48311688,0 Z",
    id: "Combined-Shape",
    fill: "#BEE4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5465143,0.0997402597 C18.4072755,0.0997402597 20.9711487,1.66012198 22.3208755,4.06232774 C19.9580164,5.07104558 18.2538212,7.31658046 18.0291491,9.98120727 L18.0291491,9.98120727 L17.6207127,9.98120727 C14.9943522,9.98120727 12.8664935,12.1006878 12.8664935,14.715279 C12.8664935,15.9680941 13.3550176,17.1070477 14.1526853,17.9537024 L5.78523429,17.9532468 C3.19567792,17.9532468 1.09714286,15.8549112 1.09714286,13.2654545 C1.09714286,10.7481212 3.0806176,8.69462626 5.57060114,8.5824856 L5.78523429,8.57766234 L7.69216831,8.57766234 L7.80736831,7.20673247 C8.14349299,3.20395636 11.5028447,0.0997402597 15.5465143,0.0997402597 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1249704,4.98701299 C27.5295086,4.98701299 29.6433039,6.50087065 30.4305538,8.71769766 L30.4305538,8.71769766 L30.845573,9.88645403 L32.0710816,9.69525195 C32.2858223,9.66173922 32.504453,9.64478338 32.7258764,9.64478338 C35.0347636,9.64478338 36.9038961,11.5060364 36.9038961,13.7990649 C36.9038961,16.091894 35.0347636,17.9532468 32.7258764,17.9532468 L32.7258764,17.9532468 L17.6207127,17.9532468 C15.8197029,17.9532468 14.3625974,16.5025247 14.3625974,14.715279 C14.3625974,12.928133 15.8194036,11.4773112 17.6207127,11.4773112 L17.6207127,11.4773112 L19.4042681,11.4773112 L19.5199668,10.10688 C19.762934,7.22488519 22.1949008,4.98701299 25.1249704,4.98701299 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0555872,28.3276301 C17.0555872,29.8692156 15.8052405,31.118961 14.2628571,31.118961 C12.7204738,31.118961 11.4701299,29.8692156 11.4701299,28.3276301 C11.4701299,27.9005423 11.56608,27.4957964 11.737733,27.133839 L13.3016603,23.154801 C13.832079,21.8053153 14.6916405,21.8043179 15.2223584,23.154801 L16.7790047,27.1150878 C16.9616149,27.4931846 17.0561758,27.9077452 17.0555872,28.3276301 L17.0555872,28.3276301 Z M25.7329898,28.3276301 C25.7329898,29.8692156 24.4826431,31.118961 22.9402597,31.118961 C21.3978764,31.118961 20.1475325,29.8692156 20.1475325,28.3276301 C20.1475325,27.9005423 20.2434826,27.4957964 20.4151356,27.133839 L21.9790629,23.154801 C22.5094816,21.8053153 23.3690431,21.8043179 23.899761,23.154801 L25.4564073,27.1150878 C25.6390175,27.4931846 25.7335784,27.9077452 25.7329898,28.3276301 L25.7329898,28.3276301 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg122);
export default __webpack_public_path__ + "static/media/122.2708c19586a48490f00a089d0fd8dcc8.svg";
export { ForwardRef as ReactComponent };